"use client";

import * as React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Close from foundation/Close
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Close = createSVGIcon(
  <path stroke="currentColor" d="m2.667 2 11.07 11.552M2 13.07 13.552 2" />,
  "Close",
  () => ({
    viewBox: "0 0 15 15",
    strokeLinecap: "square",
    strokeWidth: 2,
  })
);

/**
 * @deprecated use Close from foundation/Close
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const CloseCircle = createSVGIcon(
  <path
    d="M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M5.182 4.203a.692.692 0 1 0-.98.979L6.022 7 4.203 8.818a.692.692 0 1 0 .979.98L7 7.978l1.818 1.818a.692.692 0 1 0 .98-.979L7.978 7l1.818-1.818a.692.692 0 1 0-.979-.98L7 6.022z"
    transform="translate(-236 -21) translate(10 9) translate(226 12)"
    fill="currentColor"
    stroke="none"
    strokeWidth="1"
    fillRule="evenodd"
  />,
  "Close",
  (strictLocalize) => ({
    viewBox: "0 0 14 14",
    strokeLinecap: "square",
    titleAccess: strictLocalize({
      id: "CO1Zce",
      defaultMessage: "Close",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
  })
);
